import { Skeleton } from '@nextui-org/react'
import { FC, ReactNode } from 'react'
import { withAlpha } from '@/utils/reuseBrand'
import AnimatedNumber from './AnimatedNumber'
import Sparkline from './Sparkline'
import TrendBadge from './TrendBadge'

interface IOwnProps {
    loading:boolean
    indicador: number
    estado: string
    Icon: ReactNode
    active?: boolean
    onPress?: () => void
    formatValue?: (value: number) => string
    /* color de marca para el ícono/pill/sparkline, distinto por KPI */
    accentColor?: string
    /* tendencia semanal real (null cuando no hay semana anterior con la que comparar: se omite) */
    trendPct?: number | null
    /* últimos 7 días reales, para el sparkline. Se omite si no viene. */
    sparkline?: number[]
}

const StatusCard: FC<IOwnProps> = ({
  loading, indicador, estado, Icon, active = false, onPress, formatValue,
  accentColor = '#37417f', trendPct, sparkline
}) => {
  const hasTrend = !loading && trendPct !== undefined && trendPct !== null
  const hasSparkline = !loading && sparkline !== undefined && sparkline.length >= 2

  return (
    <button
      type='button'
      onClick={onPress}
      className={[
        'rounded-2xl shadow-md p-5 flex flex-col text-left transition-transform hover:-translate-y-0.5',
        active ? 'bg-gradient-to-br from-[#151930] to-[#37417f] text-white' : 'bg-white border border-[#afb9ff]/40'
      ].join(' ')}
    >
      <div className='flex items-start justify-between gap-2'>
        <div className='flex items-center gap-3 min-w-0'>
          <div className='flex h-11 w-11 shrink-0 items-center justify-center rounded-xl' style={{ backgroundColor: active ? 'rgba(255,255,255,0.14)' : withAlpha(accentColor, 0.12) }}>
            <span className='[&_svg]:!h-6 [&_svg]:!w-6' style={{ color: active ? '#ffffff' : accentColor }}>{Icon}</span>
          </div>
          <div className='min-w-0'>
            <p className={['text-tiny uppercase tracking-wide truncate', active ? 'text-[#afb9ff]' : 'text-slate-500'].join(' ')}>{estado}</p>
            {loading
              ? (
                <Skeleton className={['rounded-md mt-1', active ? 'bg-white/20' : ''].join(' ')}><div className='h-6 w-16' /></Skeleton>
                )
              : (
                <p className={['font-semibold leading-tight tabular-nums', active ? 'text-3xl' : 'text-2xl'].join(' ')} style={active ? undefined : { color: '#151930' }}>
                  <AnimatedNumber value={indicador} formatValue={formatValue} />
                </p>
                )}
          </div>
        </div>
        {hasTrend && <TrendBadge pct={trendPct as number} dark={active} />}
      </div>
      {hasSparkline && (
        <div className='mt-3 flex items-end justify-between gap-3'>
          <Sparkline data={sparkline as number[]} color={active ? '#ffffff' : accentColor} />
          <span className={['text-[10px] whitespace-nowrap shrink-0', active ? 'text-[#afb9ff]' : 'text-slate-400'].join(' ')}>vs. semana anterior</span>
        </div>
      )}
    </button>
  )
}

export default StatusCard
